export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fd1ad91d1e7a268a84fa8d9'
  },
  record: {
    type: 'card'
  }
};

export const QUERY = `
mutation paymentMethodUpdateOne($record: UpdateOnepaymentMethodsInput!, $filter: AutoFilledFilterUpdateOnepaymentMethodsInput!, $sort: SortUpdateOnepaymentMethodsInput, $skip: Int) {
    paymentMethodUpdateOne (record: $record, filter: $filter, sort: $sort, skip: $skip){
        recordId
        record {
            _id
            type
            bank{
                bsb
                account
                name
            }
            card{
                cardNo
                fzToken
            }
            companies
            direction
        }
    }
}
  `;
